import { useEffect, useState } from 'react'

/** Réseau disponible selon le navigateur (ne garantit pas que le serveur réponde). */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine))
  useEffect(() => {
    const on = () => {
      setOnline(true)
    }
    const off = () => {
      setOnline(false)
    }
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    return () => {
      window.removeEventListener('online', on)
      window.removeEventListener('offline', off)
    }
  }, [])
  return online
}
